import { isVideo } from "../../SelfServiceCampaignCreation/Previews/utils";

/**
 * Filter media assets based on the selected filters
 * @param {Array} mediaAssets - Array of media URLs
 * @param {Object} filters - Filter object with contentType, mediaType, and ratio arrays
 * @returns {Array} Filtered media assets
 */
export const filterMediaAssets = (mediaAssets, filters) => {
  if (!filters || !mediaAssets) return mediaAssets;

  return mediaAssets.filter((media) => {
    const mediaUrl = media.image_url;

    if (filters.showOnlyFavorites) {
      if (!media.isLiked) {
        return false;
      }
    }

    if (filters.contentType === "templates") {
      if (media.context.source !== "template") {
        return false;
      }
    }

    if (filters.contentType === "yourUploads") {
      if (media.context.source === "template") {
        return false;
      }
    }

    if (filters.contentType === "logos") {
      if (media.type !== "logo") {
        return false;
      }
    }

    if (filters.mediaType && filters.mediaType.length > 0) {
      const mediaType = getMediaType(mediaUrl);
      if (!filters.mediaType.includes(mediaType)) {
        return false;
      }
    }

    //TODO: Add ratio filter
    // if (filters.ratio && filters.ratio.length > 0) {
    // }

    return true;
  });
};

/**
 * Get the media type of an asset
 * @param {string} mediaUrl - URL of the media asset
 * @returns {string} "images" or "videos"
 */
export const getMediaType = (mediaUrl) => {
  return isVideo(mediaUrl) ? "videos" : "images";
};

/**
 * Check if a filter is active
 * @param {Array} filterArray - Array of active filter values
 * @param {string} value - Value to check
 * @returns {boolean} True if the filter is active
 */
export const isFilterActive = (filterArray, value) => {
  return filterArray && filterArray.includes(value);
};

/**
 * Get filter summary for display
 * @param {Object} filters - Current filters object
 * @returns {string} Human readable filter summary
 */
export const getFilterSummary = (filters) => {
  if (!filters) return "All media";

  const parts = [];

  if (filters.contentType === "templates") {
    parts.push("Templates only");
  }

  if (filters.contentType === "yourUploads") {
    parts.push("Your uploads only");
  }

  if (filters.contentType === "logos") {
    parts.push("Logos only");
  }

  if (filters.mediaType && filters.mediaType.length > 0) {
    parts.push(`${filters.mediaType.join(", ")} only`);
  }

  if (filters.ratio && filters.ratio.length > 0) {
    parts.push(`${filters.ratio.join(", ")} ratio`);
  }

  return parts.length > 0 ? parts.join(" • ") : "All media";
};
